import React from "react";
import clsx from "clsx";
import { useHistory } from "react-router-dom";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { Button, Typography, Box } from "@curves/ui-base";
import { CLUB_DOCUMENTS_ROUTER } from "@icoach/router/routerPath";
import { PEOPLE_TYPE, QUERY_KEYS } from "@icoach/constants/";

/** ================================
 * 📌 量身使用
 * 提醒健康申告書的填寫
 *  ================================
 */
const InBodyHealthDeclarationReminderDialog = React.forwardRef((props, ref) => {
	const { open, onClose: onCloseProps, sourceData: sourceDataProps } = props;
	if (!open) return null;
	const history = useHistory();
	const { isValidMember, peopleID, referenceType, onOpenMeasurementDialog } = sourceDataProps;

	// 前往更新健康申告書
	const handleDocHealthDeclarationUpdate = () => {
		let path = CLUB_DOCUMENTS_ROUTER.HEALTHDECLARATION.GET_CONTRACT_PATH(isValidMember ? PEOPLE_TYPE.MEMBER : PEOPLE_TYPE.INVALIDMEMBER, peopleID, 0);
		path += `?${QUERY_KEYS.IN_BODY_INTERVIEW}`;
		history.push(path);
	};

	// 不更新直接量身
	const handleStartMeasurement = () => {
		const params = {
			referenceType: referenceType,
			peopleID: peopleID,
		};
		onOpenMeasurementDialog(params);
	};

	return (
		<Dialog className={clsx("simple-content", "dialog")} PaperProps={{ className: "wx-40rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onCloseProps}>會員健康狀況更新提醒</GradientColorHeader>
			<DialogContent className="p-4">
				<Typography className="text-gray-500" paragraph>
					Curves非常重視每位會員的健康狀況
				</Typography>
				<Typography className="font-weight-bold" component="h2">
					在量身之前，請確認該會員的健康申告書是否需要進行更新呢？
				</Typography>
			</DialogContent>
			<DialogActions className="flex-y-flex-center">
				<Box className={"btn-group"}>
					<Button variant="outlined" onClick={handleDocHealthDeclarationUpdate}>
						進行更新
					</Button>
					<Button variant="contained" onClick={handleStartMeasurement}>
						直接量身
					</Button>
				</Box>
			</DialogActions>
		</Dialog>
	);
});

export default InBodyHealthDeclarationReminderDialog;
